import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

interface SectionProps {
  /** id del <section> (para deep links como /dashboard#certificados). */
  id?: string
  /** id del <h2>; enlaza el <section> vía aria-labelledby. */
  titleId?: string
  title: string
  /** Acción discreta alineada con el título (por ejemplo "Ver todos"). */
  action?: ReactNode
  className?: string
  children: ReactNode
}

// Sección sin caja: la jerarquía la llevan el tamaño del título y el espacio, no un borde.
// Mismo contrato que `Section` en @alascorporation/ui (packages/ui/src/components/section.tsx).
export function Section({ id, titleId, title, action, className, children }: SectionProps) {
  return (
    <section id={id} aria-labelledby={titleId} className={cn("scroll-mt-20", className)}>
      <div className="mb-3 flex items-baseline justify-between gap-3">
        <h2 id={titleId} className="text-lg font-semibold tracking-tight text-foreground">
          {title}
        </h2>
        {action}
      </div>
      {children}
    </section>
  )
}

// Lista con reglas finas entre filas, sin cajas ni rellenos en reposo.
export function RuledList({ className, children }: { className?: string; children: ReactNode }) {
  return <ul className={cn("divide-y divide-border border-y border-border", className)}>{children}</ul>
}

// Fila enlazable: el hover es un relleno tonal que sobresale 12px de la regla, no un borde.
export const ruledRowLink =
  "group -mx-3 rounded-md px-3 transition-colors duration-(--dur-fast) hover:bg-muted/40 focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50"
